/**
 * Environment Detection Utility
 *
 * Detects whether code is running on client or server side
 */
import { get } from 'http';

/**
 * Check if code is running on the server side
 */
export function isServer(): boolean {
  return typeof window === 'undefined';
}

/**
 * Check if code is running on the client side
 */
export function isClient(): boolean {
  return typeof window !== 'undefined';
}

/**
 * Get environment type
 */
export function getEnv(): 'server' | 'client' {
  return isServer() ? 'server' : 'client';
}

export function getEnvVar(key: string, defaultValue: string = ''): string {
  if (isServer()) {
    return process.env[key] || defaultValue;
  } else {
    // For client-side, we can only access variables prefixed with NEXT_PUBLIC_
    if (!key.startsWith('NEXT_PUBLIC_')) {
      //console.warn(`Attempting to access non-public env variable "${key}" on client side. This will return the default value.`);
      return defaultValue;
    }
    return process.env[key] || defaultValue;
  }
}

export function isDebug(): boolean {
  if (isServer()) {
    const debugValue = process.env.DEBUG || 'false';
    return debugValue.toLowerCase() === 'true' || debugValue === '1';
  }
  const debugValue = getEnvVar('NEXT_PUBLIC_DEBUG', 'false').toLowerCase();
  return debugValue === 'true' || debugValue === '1';
}

export function isProduction(): boolean {
  return process.env.NODE_ENV === 'production' && process.env.APP_ENV !== 'staging';
}

export function isDevelopment(): boolean {
  return process.env.NODE_ENV !== 'production';
}

export function isStaging(): boolean {
  return process.env.APP_ENV === 'staging';
}
